module.exports = __webpack_public_path__ + "components/flag/static/square/pr-800375e24be1009b140fbd93b1a02135.svg";